/**
 * Sign-In Coordinator
 * Determines add-in base URL and builds sign-in dialog URL.
 */

import { getPublicConfig } from "../../excel/config/getPublicConfig";

const ALLOWED_ORIGINS = [
  "https://addin-dev.exceloption.com",
  "https://addin.exceloption.com",
] as const;

const DEV_ORIGIN = "https://localhost:3000";

function isAllowedOrigin(origin: string, env: string): boolean {
  if (ALLOWED_ORIGINS.includes(origin as (typeof ALLOWED_ORIGINS)[number])) {
    return true;
  }
  if (env === "dev" && origin === DEV_ORIGIN) {
    return true;
  }
  return false;
}

export async function getSignInDialogUrl(
  mode: "oauth" | "otp" = "oauth",
  provider: string = "supabase"
): Promise<{ url: string }> {
  const baseUrl =
    typeof window !== "undefined" ? window.location.origin : "";
  if (!baseUrl) {
    throw new Error("Could not determine add-in base URL (no window)");
  }
  let env = "dev";
  try {
    const config = await getPublicConfig();
    env = config.env;
  } catch {
    // use dev allowlist
  }
  if (!isAllowedOrigin(baseUrl, env)) {
    throw new Error("Add-in origin not in allowlist: " + baseUrl);
  }
  const url = baseUrl + "/auth/start.html?mode=" + mode + "&provider=" + encodeURIComponent(provider);
  return { url };
}
